<template>
	<v-menu
		v-model="menu"
		eager
		:close-on-content-click="false"
		:max-width="$vuetify.display.mdAndUp ? width * 0.25 : width"
		:min-width="width < 430 ? width : 430"
		location="bottom right"
		transition="scale-transition"
	>
		<template #activator="{ props: btnProps }">
			<v-btn stacked v-bind="btnProps" data-tour="notifyButton">
				<v-badge :model-value="countUnread !== 0" :content="countUnread">
					<v-icon
						:icon="
							countUnread === undefined
								? 'fa-regular fa-bell fa-fade'
								: countUnread > 0
									? 'fa-regular fa-bell'
									: 'fa-regular fa-bell-slash'
						"
						color="primary"
					/>
				</v-badge>
			</v-btn>
		</template>

		<NotificationCard
			:width="width"
			:height="height"
			v-model="countUnread"
			@close="menu = false"
			@notification-link="handleNotificationLink"
		/>
	</v-menu>
</template>

<script setup lang="ts">
import { ref } from 'vue'
import { useWindowSize } from '@vueuse/core'
import NotificationCard from './NotificationCard.vue'

const { height, width } = useWindowSize()

const menu = ref(false)
const countUnread = ref(undefined)

function handleNotificationLink() {
	menu.value = false
}
</script>
